export default () => ({
  el: undefined,
  init() {
    mrp.log(`RxUtcDateConverter init`);
    this.el = this.$el;
    // set the innerHTML of the span to the correct local date/time from the utc input
    this.el.innerHTML = new Date(
      this.el.getAttribute("data-utcdate")
    ).toLocaleString();
  },
});
